<template>
  <div class="card form-2fa">
    <div class="card-header">{{t('Additional security check')}}</div>
    <div class="card-body">
      <span class="info" v-html="t('_2FaTxt')"></span>
      <titan-form ref="checkPinForm"
                  :schema="schema"
                  :renderInCard="false"
                  :model="formData"
                  @saveData="sendForm()"
      />
          <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
            {{t('Confirm code')}}
          </button>
          <div class="no-sms">{{t('Did not get the sms?')}}</div>
          <button type="button" class="btn btn-link btn-block" @click="requestNewCode()">
            {{t('Request new code')}}
          </button>
    </div>
  </div>
</template>

<script>
    import TitanForm from '../../core/Form/Form'
    import Loading from '../../core/Components/loading'

    export default {
        components: {
            TitanForm,
            Loading,
        },
        data() {
            return {
                formData: {
                    code: '',
                },
                schema: [
                    {
                        name: '',
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Security code'),
                                model: 'code',
                                required: true,
                                validator: (value) => null === value || null === String(value).match(/^[0-9]{8}$/) ? [this.t('Value must be a 8 digit number')] : [],
                            },
                        ],
                    },
                ],
            }
        },
        methods: {
            init() {
                localStorage.setItem('2FAVerification', JSON.stringify({expires: Date.now()}))
                this.$router.push({name: 'dashboard'})
                /*
                if (false === this.requiresVerification()) {
                    this.$router.push({name: 'dashboard'})
                    return;
                }
                this.$store.dispatch('account/initTwoFa').then(response => {
                    if (response.hasOwnProperty('code')) {
                        this.formData.code = response.code;
                    }
                    this.$store.dispatch('alert/success', this.t(response.status) + ' ' + (response.cellphone || ''))
                }).catch(error => this.$store.dispatch('alert/error', error.status));
                 */
            },
            sendForm() {
                this.$store.dispatch('account/verifyTwoFACode', this.formData).then(response => {
                    this.$store.dispatch('alert/success', response.status)
                    this.$store.getters['account/userStore'].getLoggedUser().set('twoFAVerification',{expires: Date.now()});
                    this.$router.push({name: 'dashboard'})
                }).catch(error => this.$store.dispatch('alert/error', error.status))
            },
            resendCode() {
                this.$store.dispatch('account/initTwoFa', {newCode: false}).then(response => {
                    if (response.hasOwnProperty('code')) {
                        this.formData.code = response.code;
                    }
                    this.$store.dispatch('alert/success', this.t(response.status) + ' ' + (response.cellphone || ''))
                }).catch(error => this.$store.dispatch('alert/error', error.status))
            },
            requestNewCode() {
                this.$store.dispatch('account/initTwoFa', {newCode: true}).then(response => {
                    if (response.hasOwnProperty('code')) {
                        this.formData.code = response.code;
                    }
                    this.$store.dispatch('alert/success', this.t(response.status) + ' ' + (response.cellphone || ''))
                }).catch(error => this.$store.dispatch('alert/error', error.status))
            },
            requiresVerification() {
                //return true;
                const passed2FA = localStorage.getItem('2FAVerification')

                if (null === passed2FA) {
                    return true
                }
                try {
                    if (passed2FA.expires > Date.now() - 30 * 24 * 60 * 60 * 1000) { // 1 month
                        return false
                    }
                } catch (e) {
                }

                return true
            },
        },
        created() {
            this.init()
        },
    }
</script>

<style lang="scss">
  .info {
    display:block;
    font-size:0.9em;
    color:gray;
    padding-bottom:10px;
  }
  .no-sms {
    text-align: center;
    margin-top:10px;
    font-size:0.9em;
    color:gray;
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/TwoFA.vue